import http from '../../http'

const getReport = () => http.get(`transactions/reports/dashboard/main`)

const getMainPartner = () => http.get(`partners/main`)

const getBankReport = () => http.get(`transactions/reports/bank`)

const getBankBalance = (page = 1, limit = 10, query = '') => http.get(`transactions/balance/bank?page=${page}&limit=${limit}${query}`)

const transactionsIssuance = payload => http.post('transactions/issuance', payload)

const biRequests = (payload, query) => http.post(`bi-v2/requests?${query}`, payload)

export {
  getReport,
  getMainPartner,
  getBankReport,
  getBankBalance,
  transactionsIssuance,
  biRequests
}
